import React, { useState } from "react";
import DocumentMeta from "react-document-meta";
import Config from "../config.json";
import { Link } from "react-router-dom";
import aboutPajoohyar from "../Images/about pajoohyar.png";
import bannerPajoohyar from "../Images/download-pajoohyar-banner.png";
const timelineData = [
  { year: "۱۳۹۰", content: ["ارایه نسخه بتا به صورت افزونه مرورگر فایرفاکس"] },
  {
    year: "۱۳۹۲",
    content: [
      "ارایه نسخه 1  مطابق آخرین نسخه فایرفاکس",
      "فعال شدن امکان انتقال داده‌ها بین کتابخانه نور",
    ],
  },
  {
    year: "۱۳۹۳",
    content: [
      "ارایه نسخه 1.5 همراه با امکان همزمان‌سازی اطلاعات در «اَبر پژوهیار»",
    ],
  },
  {
    year: "۱۳۹۴",
    content: [
      "ارایه نسخه 2 نصب نسخه به صورت نسخه‌ی رومیزی (desktop)",
      "قابلیت نصب و استفاده مستقل از مرورگر",
    ],
  },
  {
    year: "۱۳۹۶",
    content: [
      "توسعه و بهبود نسخه 2",
      "نگارش بیش از 50 شیوه استنادی بومی",
      "نگارش بیش از 20 پایگاه پشتیبانی",
    ],
  },
  {
    year: "۱۳۹۸",
    content: ["توسعه زیرساخت سایت و سرور", "برگزاری 20 کارگاه آموزشی پژوهیار"],
  },
  {
    year: "۱۴۰۰",
    content: ["راه اندازی بلاگ پژوهیار با تولید محتوای آموزشی و پژوهشی "],
  },
  {
    year: "۱۴۰۲",
    content: [
      "تحلیل و برنامه‌ریزی برای توسعه نسخه جدید پژوهیار مبتنی بر آخرین نسخه زوترو",
    ],
  },
  {
    year: "۱۴۰۴",
    content: [
      "انتشار نسخه 3 با رابط کاربری جدید",
      "امکان فعال سازی از طریق سامانه یکپارچه نور (ای نور)",
    ],
  },
];
const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | درباره ما",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const AboutUs = () => {
  const [selectedYear, setSelectedYear] = useState(timelineData[0]);

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample hero-about">
        <div className="hero-sample-right hero-about-right">
          <h1>درباره پژوهیار</h1>

          <p className="text-justify">
            «پژوهیار» اولین نرم‌افزار مدیریت استناددهی متن باز فارسی زبان است که
            بر پایه نرم افزار زوترو طراحی شده است. این نرم افزار محققان و
            پژوهشگران را در امر پژوهش و مستند‌سازی نتایج پژوهشی یاری می‌کند.
          </p>
        </div>
        <div className="hero-sample-left hero-about-left">
          <img src={aboutPajoohyar} className="about-img" alt="cantact-us" />
        </div>
      </section>
      <section className="about-timeline-section text-right">
        <h1>پژوهیار؛ از ابتدا تا امروز</h1>
        <div className="about-timeline-parent">
          <div className="about-timeline-container">
            <div className="about-timeline-year-boxes">
              {timelineData.map((item, index) => (
                <div
                  key={item.year}
                  className={`about-timeline-box-parent ${
                    selectedYear.year === item.year &&
                    index !== timelineData.length - 1
                      ? "active"
                      : ""
                  } ${index === timelineData.length - 1 ? "activeCfix2" : ""}`}>
                  <div
                    key={item.year}
                    className="about-timeline-year-box"
                    onClick={
                      index !== timelineData.length - 1
                        ? () => setSelectedYear(item)
                        : undefined
                    }>
                    {item.year}
                  </div>
                  <div
                    className={`about-timeline-content ${
                      selectedYear.year === item.year ? "activeC" : ""
                    } ${
                      index === timelineData.length - 1 ? "activeCfix" : ""
                    }`}>
                    {selectedYear.year === item.year ? (
                      <ul>
                        {item.content.map((text, index) => (
                          <li key={index}>
                            <div className="about-circle-icon">
                              <i className="fas fa-circle"></i>
                            </div>
                            {text}
                          </li>
                        ))}
                      </ul>
                    ) : index === timelineData.length - 1 ? (
                      <ul>
                        {item.content.map((text, index) => (
                          <li key={index}>
                            <div className="about-circle-icon">
                              <i className="fas fa-circle"></i>
                            </div>
                            {text}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="about-us-items">
        <div className="about-us-item-card">
          <h3>داستان پژوهیار</h3>
          <p className="text-justify p-3">
            پژوهیار از سال 1390 تا کنون به‌عنوان نرم‌افزار استناددهی بومی برای
            فارسی‌زبانان راه‌اندازی شد تا نیاز پژوهشگران ایرانی به ابزاری کارآمد
            برای مدیریت منابع علمی و استناددهی برطرف کند. این نرم‌افزار بر اساس
            زوترو (Zotero) ساخته شده، اما به‌طور خاص برای کاربران ایرانی
            بهینه‌سازی شده است. این نرم‌افزار ابتدا به صورت افزونه مرورگر و سپس
            به صورت نسخه دسکتاپ همراه با دو افزونه مرورگر و افزونه ورد عرضه شده
            است. پژوهیار به‌طور مداوم به‌روزرسانی می‌شود تا با بهبود ویژگی‌ها و
            رفع نیازهای کاربران، تجربه‌ای بهتر و کارآمدتر را برای پژوهشگران
            فراهم کند.
          </p>
        </div>

        <div className="about-us-item-card">
          <h3>چشم‌انداز پژوهیار </h3>
          <p className="text-justify">
            پژوهیار در تلاش است تا به مرجع اصلی و قابل اعتماد نرم‌افزارهای
            مدیریت منابع و استنادهی برای فارسی‌زبانان تبدیل شود؛ ابزاری که
            هم‌پای نرم‌افزارهای بین‌المللی، اما با درک عمیق از نیازها و زبان
            پژوهشگران ایرانی، مسیر پژوهش علمی را ساده‌تر، دقیق‌تر و بومی‌تر
            می‌کند. با راه اندازی نسخه تحت وب فرآیند پژوهش کاربر دسترس پذیر و
            سریع تر پیش خواهد رفت.
          </p>
        </div>
        <div className="about-us-item-card">
          <h3>چرا پژوهیار؟</h3>
          <p className="text-justify">
            پژوهیار به‌عنوان یک نرم‌افزار استناددهی بومی، برای پاسخگویی به نیاز
            پژوهشگران ایرانی طراحی شده است. این نرم‌افزار با پشتیبانی از زبان
            فارسی و استانداردهای بین‌المللی، فرآیند مدیریت منابع و استناددهی را
            ساده و دقیق می‌کند. پژوهیار ابزاری کارآمد برای پژوهشگران است که به
            دنبال راحتی، دقت و انطباق با نیازهای علمی خود هستند.
          </p>
        </div>
      </section>
      <section className="hero-sample about-us-download-banner">
        <div className="hero-sample-right hero-about-download-banner-right">
          <h1>پژوهیار را دانلود کنید</h1>
          <div className="about-download-btn-container">
            <Link to="/product" className="about-download-btn">
              دانلود
            </Link>
          </div>
        </div>
        <div className="hero-sample-left hero-about-download-banner-left">
          <img
            src={bannerPajoohyar}
            className="about-download-banner-img"
            alt="cantact-us"
          />
        </div>
      </section>
    </DocumentMeta>
  );
};

export default AboutUs;
